export const GLOBAL_QUERY_OPTIONS = {
  /**
   * 5 min as the default stale time for all queries
   */
  staleTime: 5 * 60 * 1000,
  /**
   * No retries by default for failed queries
   */
  retry: 0,
  /**
   * Disable refetching on window focus by default for all queries
   */
  refetchOnWindowFocus: false,
} as const

export const GLOBAL_MUTATION_OPTIONS = {
  /**
   * No retries by default for failed mutations to prevent duplicate side-effects
   */
  retry: 0,
  /**
   * Only execute mutations when there is an active network connection
   */
  networkMode: 'online',
} as const
